import { render } from "./EffectViewer.vue?vue&type=template&id=23f73810&scoped=true"
import script from "./EffectViewer.vue?vue&type=script&lang=js"
export * from "./EffectViewer.vue?vue&type=script&lang=js"

import "./EffectViewer.vue?vue&type=style&index=0&id=23f73810&scoped=true&lang=css"

import exportComponent from "/home/lw8dl1214/actions-runner/_work/AIPR-Frontend/AIPR-Frontend/haleon-ar-detector/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23f73810"]])

export default __exports__